var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},[_vm._l((_vm.list),function(item,index){return [_c('div',{key:index,staticClass:"tab  ",class:_vm.currentIndex==index?'active':'',on:{"click":function($event){return _vm.tabClick(index,item)}}},[_c('img',{attrs:{"src":item.image}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.title))])])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fa8ec66","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/FwTab.vue
// module id = 927
// module chunks = 0